module.exports = __webpack_public_path__ + "img/file.63a5c7f2.svg";